// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useTranslation } from 'react-i18next';
import ContinueButton from '../../../../components/continueButton/ContinueButton';
import { useNavigateKeepSearch } from '@hooks/useNavigateKeepSearch';

import { RootRoutes } from '@/index';
import { useSession } from '@/common/authorization/context/Session';

import './Otp.less';

interface OtpInstructionsProps {
  onContinue: () => void;
}

const TRANSLATION_ROOT = 'self-service.auth-method.otp';

const OtpInstructions = ({ onContinue }: OtpInstructionsProps) => {
  const { t } = useTranslation();
  const navigateKeepSearch = useNavigateKeepSearch();
  const { userInfo } = useSession();

  const handleDoThisLater = () => {
    navigateKeepSearch(RootRoutes.SELF_SERVICE);
  };

  return (
    <div className="instructions">
      {/* Title and description */}
      <h1 className="instructions-title">{t(`${TRANSLATION_ROOT}.title`)}</h1>
      <div className="instructions-description">{t(`${TRANSLATION_ROOT}.description`)}</div>

      {/* Email information */}
      <div className="instructions-email-label">{t(`${TRANSLATION_ROOT}.registered-email`)}</div>
      <div className="instructions-email">{userInfo?.email || ''}</div>
      <div className="instructions-email-helper">{t(`${TRANSLATION_ROOT}.not-your-email`)}</div>

      {/* Continue or cancel */}
      <div className="instructions-actions">
        <ContinueButton
          onClick={onContinue}
          aria-label="continue-button"
          label={t('common.continue-button')}
          secondaryButton={{
            'aria-label': 'cancel-button',
            label: t('common.cancel'),
            onClick: handleDoThisLater,
          }}
        />
      </div>
    </div>
  );
};

export default OtpInstructions;
